import { ChevronLeft, ChevronRight } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { IconButton } from '@/components/ui/Button'
import { formatMonth, shiftMonth } from '../dates'

export function MonthNav({
  month,
  onChange,
  max,
}: {
  month: string
  onChange: (month: string) => void
  max?: string
}) {
  const { t } = useTranslation('attendance')
  return (
    <div className="flex items-center gap-1">
      <IconButton
        label={t('Previous month')}
        icon={<ChevronLeft />}
        size="icon-sm"
        variant="secondary"
        onClick={() => onChange(shiftMonth(month, -1))}
      />
      <p className="min-w-36 text-center text-sm font-semibold text-ink" aria-live="polite">
        {formatMonth(month)}
      </p>
      <IconButton
        label={t('Next month')}
        icon={<ChevronRight />}
        size="icon-sm"
        variant="secondary"
        disabled={max !== undefined && month >= max}
        onClick={() => onChange(shiftMonth(month, 1))}
      />
    </div>
  )
}
